import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const { processSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    processSession(sessionId)
      .then((userData) => {
        window.history.replaceState(null, '', '/');
        if (userData?.role === 'admin') {
          navigate('/admin', { replace: true, state: { user: userData } });
        } else {
          navigate('/', { replace: true, state: { user: userData } });
        }
      })
      .catch(() => {
        navigate('/auth', { replace: true });
      });
  }, [processSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin mx-auto mb-4" style={{ borderColor: 'var(--accent)', borderTopColor: 'transparent' }} />
        <p className="font-body text-sm" style={{ color: 'var(--text-muted)' }}>Autenticazione in corso...</p>
      </div>
    </div>
  );
}
